/** 示例：sidebar: state => state.sidebar,
 *  示例：sidebar: (state) => (id) => {
 *         return state.todos.find(todo => todo.id === id)
 *       },
 */
const getters = {
  sidebar: state => 'getters'
}
  export default getters
  